var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ValidationObserver',{ref:"observer",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var valid = ref.valid;
return [_c('NavTabs',{attrs:{"customClass":"capitalize_title","tabs":_vm.tabs,"activeTab":_vm.newActiveTab},on:{"sendData":_vm.updateData}}),_c('SlotScopeWatcher',{attrs:{"value":valid},on:{"change":function($event){return _vm.$emit('validChanged', valid)}}})]}}])})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }